import { toZonedTime } from 'date-fns-tz'
import { differenceInCalendarDays, isToday, isYesterday, format } from 'date-fns'

export function formatLastUpdated (dateString) {
  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    console.error('Invalid date:', dateString)
    return null
  }

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const zonedDate = toZonedTime(date, userTimeZone)
  const today = toZonedTime(new Date(), userTimeZone)

  const daysDifference = differenceInCalendarDays(today, zonedDate)

  if (isToday(zonedDate)) {
    return { key: 'time.today' }
  } else if (isYesterday(zonedDate)) {
    return { key: 'time.yesterday' }
  } else if (daysDifference <= 6) {
    return { key: 'time.daysAgo', count: daysDifference }
  } else if (daysDifference <= 13) {
    return { key: 'time.weeksAgo', count: 1 }
  } else if (daysDifference <= 20) {
    return { key: 'time.weeksAgo', count: 2 }
  } else {
    return {
      key: 'time.fullDate',
      date: format(zonedDate, 'do MMMM yyyy') // or use `Intl.DateTimeFormat`
    }
  }
}
